import { FaPhoneAlt } from "react-icons/fa";
import { IoIosGlobe } from "react-icons/io";

const SurveySheet = ({ children, survey }) => {
  return (
    <div
      className="bg-white mx-auto shadow-md relative"
      style={{ height: "1123px", width: "850px", boxSizing: "border-box" }}
    >
      <div>
        <img
          className="w-full"
          src={`/assets/survey/survey-banner/header_${survey?.configuration?.colorSurvey || "verde"}.png`}
        />
      </div>
      {children}
      <div className="absolute bottom-5 left-0 right-0">
        <div className="relative">
          <img
            className="w-full mt-10"
            src={`/assets/survey/survey-banner/footer_${survey?.configuration?.colorSurvey || "verde"}.png`}
          />

          <img
            className="absolute h-12 rounded-md"
            style={{ top: "50%", transform: "translateY(-50%)", left: "60px" }}
            src={`${survey?.configuration?.imgURL || "/assets/logo_carro.png"}`}
          />

          <div
            className="absolute flex flex-col gap-2"
            style={{
              top: "50%",
              transform: "translateY(-50%)",
              left: "400px",
            }}
          >
            {survey?.configuration?.websiteURL && (
              <div className="flex gap-2 items-center">
                <div className="bg-gray-100 rounded-full w-5 h-5 flex justify-center items-center">
                  <IoIosGlobe />
                </div>
                <span className="text-white text-sm">
                  {survey?.configuration?.websiteURL}
                </span>
              </div>
            )}
            {survey?.configuration?.phoneNumber && (
              <div className="flex gap-2 items-center">
                <div className="bg-gray-100 rounded-full w-5 h-5 flex justify-center items-center">
                  <FaPhoneAlt fontSize={10} />
                </div>
                <span className="text-white text-sm">
                  {survey?.configuration?.phoneNumber}
                </span>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SurveySheet;
